import { Field, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'

@ObjectType()
export class SyncInfo {
  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  externalId?: string
}
